import React, { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DndTable } from "@components/DND";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { Awesome, DevModal } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function EventGroupListScreen() {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:event_group:list"));
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [updatedEventGroup, setUpdatedEventGroup] = useState({});
    const [eventGroup, setEventGroup] = useState("");
    const [errors, setErrors] = useState({});
    const { api_post } = useRequest();

    const headerTools = (
        <Button size="sm" variant="dark" onClick={() => setShowModal(true)}>
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Button>
    );

    const header = (
        <>
            <Link to={url_reverse("admin:event:list")}>{t("Настройки")}</Link>
            <span> – </span>
            {t("Управление разделами")}
        </>
    );
    const handleCloseEditModal = () => {
        setUpdatedEventGroup({});
        setShowEditModal(false);
    };
    const submitEventGroupEdit = (ev) => {
        api_post(ev, url_reverse("api:event_group:list"), {
            params: { action: "update_event_group", ...updatedEventGroup },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setUpdatedEventGroup({});
                    setShowEditModal(false);
                    setErrors({});
                } else if (resp.errors) {
                    setErrors(resp.errors);
                }
            },
        });
    };
    const submitEventGroupCreate = (ev) => {
        api_post(ev, url_reverse("api:event_group:list"), {
            params: { action: "add_event_group", name: eventGroup },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setEventGroup("");
                    setShowModal(false);
                    setErrors({});
                } else if (resp.errors) {
                    setErrors(resp.errors);
                }
            },
        });
    };
    const handleCloseEventGroupCreateModal = () => {
        setEventGroup({});
        setShowModal(false);
    };

    const handleEventGroup = (ev) => {
        setEventGroup(ev.target.value);
    };
    const handleUpdatedEventGroup = (ev) => {
        setUpdatedEventGroup((prevState) => {
            return {
                ...prevState,
                name: ev.target.value,
            };
        });
    };

    return (
        <DefaultLayout>
            <ListingCard header={header} headerTools={headerTools}>
                {errors?.event_group_exists && <Alert variant="danger">{errors.event_group_exists}</Alert>}
                <EventGroupItemListSortable
                    apiData={apiData}
                    setApiData={setApiData}
                    setUpdatedEventGroup={setUpdatedEventGroup}
                    setShowEditModal={setShowEditModal}
                />
                <DevModal
                    size="lg"
                    show={showModal}
                    onHide={handleCloseEventGroupCreateModal}
                    header={t("Создать раздел")}
                    body={
                        <FormFieldGroup
                            label={
                                <span>
                                    {t("Название")} <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                                </span>
                            }
                        >
                            <DevForm.TextInput
                                name="event_group"
                                type="text"
                                onChange={handleEventGroup}
                                value={eventGroup}
                            />
                            {errors?.name && (
                                <div className="error" style={{ color: "red" }}>
                                    {errors.name}
                                </div>
                            )}
                        </FormFieldGroup>
                    }
                    footer={
                        <DevForm.Button variant="primary" name="save" onClick={submitEventGroupCreate}>
                            {t("Сохранить")}
                        </DevForm.Button>
                    }
                    renderWrapper={(children) => <Form>{children}</Form>}
                />
                <DevModal
                    size="lg"
                    show={showEditModal}
                    onHide={handleCloseEditModal}
                    header={t("Редактировать раздел")}
                    body={
                        <FormFieldGroup
                            label={
                                <span>
                                    {t("Название")} <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                                </span>
                            }
                        >
                            <DevForm.TextInput
                                name="event_group"
                                type="text"
                                onChange={handleUpdatedEventGroup}
                                value={updatedEventGroup.name || ""}
                            />
                            {errors?.name && (
                                <div className="error" style={{ color: "red" }}>
                                    {errors.name}
                                </div>
                            )}
                        </FormFieldGroup>
                    }
                    footer={
                        <DevForm.Button variant="primary" name="save" onClick={submitEventGroupEdit}>
                            {t("Сохранить")}
                        </DevForm.Button>
                    }
                    renderWrapper={(children) => <Form>{children}</Form>}
                />
            </ListingCard>
        </DefaultLayout>
    );
}

function EventGroupItemListSortable({ apiData, setApiData, setUpdatedEventGroup, setShowEditModal }) {
    const handleOpenEditModal = (object) => {
        setUpdatedEventGroup(object);
        setShowEditModal(true);
    };

    return (
        <DndTable
            apiData={apiData}
            setApiData={setApiData}
            apiUrl={url_reverse("api:event_group:list")}
            tds={(el) => (
                <>
                    <td style={{ width: "30%" }}>{el.name}</td>
                    <td className={"dmg-table-row-tools"}>
                        <Button size="sm" variant="outline-primary" onClick={() => handleOpenEditModal(el)}>
                            <Awesome type="pencil" />
                        </Button>
                    </td>
                </>
            )}
        />
    );
}
